import React from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { arrayMove, SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Typography, TextField, IconButton } from '@mui/material';
import { DragHandle, Audiotrack } from '@mui/icons-material';

const SortableItem = ({ value, sessions, handleChallengesDay }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: Object.keys(value)[0] });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    backgroundColor: isDragging ? 'rgb(235, 235, 235)' : undefined,
    zIndex: isDragging ? 1 : undefined,
  };

  let label = "";
  let item = sessions.find(
    obj => obj.session_id === parseInt(Object.keys(value)[0])
  );
  if (item) {
    label = item.session_name;
  }
  const name = item.session_id;

  return (
    <Box
      ref={setNodeRef}
      style={style}
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1,
        px: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        '&:last-child': {
          borderBottom: 'none'
        },
        '&:hover': {
          bgcolor: 'action.hover'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <Audiotrack sx={{ mr: 1, color: 'text.secondary', fontSize: '1.1rem' }} />
        <Typography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.875rem'
          }}
        >
          {label}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          type="text"
          size="small"
          label="Day Label"
          name={`days-${name}`}
          value={value[name][0]}
          onChange={handleChallengesDay}
          sx={{
            width: '120px',
            '& .MuiInputBase-root': {
              height: '36px'
            }
          }}
        />

        <IconButton
          size="small"
          sx={{
            cursor: 'grab',
            '&:active': { cursor: 'grabbing' },
            color: 'text.secondary'
          }}
          {...attributes}
          {...listeners}
        >
          <DragHandle />
        </IconButton>
      </Box>
    </Box>
  );
};

const SortableSessions = ({ items, onSortEnd, sessions, handleChallengesDay }) => {
  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => Object.keys(item)[0] === active.id);
      const newIndex = items.findIndex((item) => Object.keys(item)[0] === over.id);
      onSortEnd({ oldIndex, newIndex });
    }
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items.map((item) => Object.keys(item)[0])}>
        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}`}
            value={value}
            sessions={sessions}
            handleChallengesDay={handleChallengesDay}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default SortableSessions;